const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse, Modal} from 'bootstrap';

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_form.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
//require('./utilities/pdw_slider.js');
//require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/pdw_aos.js');
//require('./utilities/pdw_woocommerce.js');


// nettoie tous les tabs du megamenu à chaque changement d’onglet, puis n’active que la cible (corrige l’état “double actif” si jamais il survient à nouveau)
(function () {
    // Active un pane dans LA modale actuellement ouverte
    function activateInModal(modalEl, triggerEl) {
        const targetSel = triggerEl.getAttribute('data-bs-target') || triggerEl.getAttribute('href');
        if (!targetSel || !targetSel.startsWith('#')) return;

        const tabContent = modalEl.querySelector('.tab-content');
        const targetPane = modalEl.querySelector(targetSel);
        if (!tabContent || !targetPane) return;

        // 1) NAV : un seul actif
        modalEl.querySelectorAll('[data-bs-toggle="tab"]').forEach(a => {
            a.classList.remove('active');
            a.setAttribute('aria-selected', 'false');
            a.removeAttribute('tabindex');
        });
        triggerEl.classList.add('active');
        triggerEl.setAttribute('aria-selected', 'true');

        // 2) TABS : nettoyer puis activer la cible
        tabContent.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('show', 'active'));
        targetPane.classList.add('show', 'active');
    }

    // À l’ouverture de n’importe quelle modale du méga-menu : assainir l’état
    document.addEventListener('shown.bs.modal', (e) => {
        const modalEl = e.target.closest('.pdw-desktop-megamenu-v2-modal');
        if (!modalEl) return;

        // on prend la nav active, sinon le premier onglet
        const current = modalEl.querySelector('.nav-link.active') || modalEl.querySelector('[data-bs-toggle="tab"]');
        if (current) activateInModal(modalEl, current);
    });

    // Délégation de clic : forcer l’activation *à chaque clic* (même si Bootstrap ne déclenche pas 'shown')
    document.addEventListener('click', (e) => {
        const modalShown = document.querySelector('.pdw-desktop-megamenu-v2-modal.show');
        if (!modalShown) return;

        const trigger = e.target.closest('[data-bs-toggle="tab"]');
        if (!trigger || !modalShown.contains(trigger)) return;

        // on laisse le clic (pas besoin de preventDefault), mais on force l’état juste après
        setTimeout(() => activateInModal(modalShown, trigger), 0);
    });
})();